import { type SectionConfig } from '@/utils/get-matched-section'

// Breadcrumb parent shared by every page under a property drill-in.
const propertyParent = {
  label: 'Properties',
  href: (_params: unknown, orgSlug?: string) =>
    `/${orgSlug}/technician/properties`
}

// Sub-pages of one property breadcrumb back to that property's overview.
const propertyDetailParent = {
  label: (params: unknown) => {
    const p = params as { customerId?: string }
    return p?.customerId ? `${p.customerId}` : 'Property'
  },
  href: (params: unknown, orgSlug?: string) => {
    const p = params as { customerId?: string }
    return `/${orgSlug}/technician/properties/${p?.customerId ?? ''}`
  }
}

export const sectionConfig: SectionConfig = {
  '/technician/dashboard': {
    title: 'Dashboard',
    showBreadcrumbs: false
  },
  '/technician/work-orders': {
    title: 'Work Orders'
  },
  '/technician/work-orders/[taskId]': {
    title: (params) => {
      const p = params as { taskId?: string }
      return p?.taskId ? `${p.taskId}` : 'Task Detail'
    },
    parentBreadcrumb: {
      label: 'Work Orders',
      href: (_params, orgSlug) => `/${orgSlug}/technician/work-orders`
    }
  },
  '/technician/equipment': {
    title: 'Equipment',
    description: 'Shipped to you or your company'
  },
  '/technician/team': {
    title: 'Team'
  },
  '/technician/documents': {
    title: 'Documents',
    description: 'Your signed agreements with WorldVue'
  },
  '/technician/schedule': {
    title: 'Schedule'
  },
  '/technician/properties': {
    title: 'Properties'
  },
  '/technician/properties/[customerId]': {
    title: (params) => {
      const p = params as { customerId?: string }
      return p?.customerId ? `${p.customerId}` : 'Property'
    },
    parentBreadcrumb: propertyParent
  },
  '/technician/properties/[customerId]/networking/overview': {
    title: 'Networking Overview',
    parentBreadcrumb: propertyDetailParent
  },
  '/technician/properties/[customerId]/networking/topology': {
    title: 'Network Topology',
    parentBreadcrumb: propertyDetailParent
  },
  '/technician/properties/[customerId]/networking/access-points': {
    title: 'Access Points',
    parentBreadcrumb: propertyDetailParent
  },
  '/technician/properties/[customerId]/networking/switches': {
    title: 'Switches',
    parentBreadcrumb: propertyDetailParent
  },
  '/technician/properties/[customerId]/networking/appliances': {
    title: 'Appliances',
    parentBreadcrumb: propertyDetailParent
  },
  '/technician/properties/[customerId]/networking/managed-devices': {
    title: 'Managed Devices',
    parentBreadcrumb: propertyDetailParent
  },
  '/technician/properties/[customerId]/tv-experience/channels': {
    title: 'Channels',
    parentBreadcrumb: propertyDetailParent
  },
  '/technician/properties/[customerId]/tv-experience/displays': {
    title: 'Displays',
    parentBreadcrumb: propertyDetailParent
  },
  '/technician/properties/[customerId]/rooms': {
    title: 'Room View',
    parentBreadcrumb: propertyDetailParent
  }
}
